import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAuthEventName, readStoredUser } from '../utils/auth';

export default function Header() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [user, setUser] = useState(() => readStoredUser());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    const syncUser = () => {
      setUser(readStoredUser());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('storage', syncUser);
    window.addEventListener(getAuthEventName(), syncUser);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('storage', syncUser);
      window.removeEventListener(getAuthEventName(), syncUser);
    };
  }, []);

  const linkStyle = {
    color: '#898D08',
    fontSize: isMobile ? '18px' : '28px',
    fontFamily: 'Milonga, serif',
    margin: isMobile ? '0 10px' : '0 20px',
    textDecoration: 'none',
    textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    whiteSpace: 'nowrap',
  };

  const loginLinkStyle = {
    ...linkStyle,
    position: 'absolute',
    top: isMobile ? '10px' : '8px',
    right: isMobile ? '16px' : '28px',
    margin: 0,
    zIndex: 4,
    fontSize: isMobile ? '16px' : '24px',
  };

  return (
    <>
      <div
        style={{
          width: '100%',
          position: 'relative',
          backgroundImage: "url('/images/Header.png')",
          backgroundSize: 'cover',
          backgroundRepeat: 'repeat',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          overflow: 'hidden',
          margin: 0,
          padding: 0,
        }}
      >
        <Link to="/login" style={loginLinkStyle}>{user ? 'Account' : 'Login'}</Link>

        {/* Top Bar */}
        <div style={{ width: '110%', height: '54px', lineHeight: 0, position: 'relative', left: '-5px',}}>
          <img
            src="/images/TopNavigationBar.png"
            alt="Top Bar"
            style={{
              width: '100%',
              height: '100%',
              display: 'block',
              margin: 0,
              padding: 0,
              zIndex: 2,
            }}
          />
        </div>

        {/* Sign */}
        <img
          src="/images/Sign.png"
          alt="Traveler's Tavern"
          style={{
            width: isMobile ? '80%' : 'auto',
            height: 'auto',
            margin: 0,
            padding: 0,
            display: 'block',
          }}
        />

        {/* Navigation Links */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            margin: isMobile ? '10px 0 20px' : '20px 0 30px',
          }}
        >
          <Link to="/" style={linkStyle}>Home</Link>
          <Link to="/about" style={linkStyle}>About Me</Link>
          <Link to="/contact" style={linkStyle}>Contact</Link>
          <Link to="/gallery" style={linkStyle}>Gallery</Link>
          <Link to="/projects" style={linkStyle}>Projects</Link>
        </div>
      </div>

      {/* Bottom Bar*/}
      <div style={{ width: '110%', height: '54px', lineHeight: 0, overflowX: 'hidden', position: 'relative', left: '-5px',}}>
        <img
          src="/images/TopNavigationBar.png"
          alt="Bottom Bar"
          style={{
            width: '100%',
            height: '100%',
            display: 'block',
            margin: 0,
            padding: 0,
            zIndex: 2,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.5)'
          }}
        />
      </div>
    </>
  );
}
